import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Box from '@mui/material/Box'
import TablePagination from '@mui/material/TablePagination'
import { getComparator } from '../../../Utils/SortingUtils/getComparator'
import { stableSort } from '../../../Utils/SortingUtils/stableSort'
import EnhancedTableHead from '../../../Components/TableComponents/EnhancedTableHead'
import { StyledTableCell } from '../../../Components/TableComponents/StyledTableCell'
import { headCellsSepaMandates } from '../../../Utils/TableUtils/headCells'
import Open from '../../../img/icons/suppr.svg'
import Modify from '../../../img/icons/modify.svg'
import { useNavigate } from 'react-router'
import { Tooltip } from '@mui/material'

function SepaTable(props) {
    const [order, setOrder] = React.useState('desc')
    const [orderBy, setOrderBy] = React.useState('dateCreation')
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const navigate = useNavigate()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        props.setPage(0)
    }

    const emptyRows =
        props.page > 0 ? Math.max(0, (1 + props.page) * rowsPerPage - props.rows.length) : 0

    const visibleRows = React.useMemo(
        () =>
            stableSort(props.rows, getComparator(order, orderBy)).slice(
                props.page * rowsPerPage,
                props.page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, props.page, rowsPerPage, props.rows],
    )

    return (
        <Box sx={{
            width: '100%',
            [`& .${tableCellClasses.root}`]: {
                borderBottom: "none"
            }
        }}>
            <TableContainer>
                <Table
                    aria-labelledby="tableTitle"
                >
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={props.rows.length}
                        headCells={headCellsSepaMandates(props.isMcdo)}
                    />
                    <TableBody>
                        {visibleRows.map((row, index) => {

                            return (
                                <TableRow key={`sepatable-${index}`}>
                                    <StyledTableCell>
                                        <Tooltip title={row.raisonSociale} enterTouchDelay={0}>
                                            <span>{row.raisonSociale && row.raisonSociale}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    {props.isMcdo &&
                                        <StyledTableCell>{row.numRestaurantMCDO}</StyledTableCell>
                                    }
                                    <StyledTableCell>
                                        <Tooltip title={row.sites} enterTouchDelay={0}>
                                            <span>{row.sites && row.sites}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Tooltip title={row.adresse} enterTouchDelay={0}>
                                            <span>{row.adresse && row.adresse}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell style={{ "maxWidth": '250px' }}>
                                        <Tooltip title={row.iban} enterTouchDelay={0}>
                                            <span>{row.iban && row.iban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Tooltip title={row.ribFichier} enterTouchDelay={0}>
                                            <span>{row.ribID && <div className="mandates--link__container" onClick={() => props.getDocument(row.ribID, row.ribFichier)}><span className="table--link mandates--link mandates--linknomargin">{row.ribFichier}</span><img src={Open} alt="Ouvrir" className="table--icon" /></div>}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <Tooltip title={row.mandatFichier} enterTouchDelay={0}>
                                            <span>{<div className="mandates--link__container" onClick={row.statut === "Signé" ? () => props.getDocument(row.mandatID, row.mandatFichier) : () => navigate(`/sepa-update?sepaid=${row.sepaId}`)}><span className="table--link mandates--link mandates--linknomargin sepa--link">{row.mandatFichier ? row.mandatFichier : "A compléter / signer"}</span><img src={row.statut === "Signé" ? Open : Modify} alt="Ouvrir" className="table--icon" /></div>}</span>
                                        </Tooltip>
                                    </StyledTableCell>
                                    <StyledTableCell>{row.dateCreation && new Date(row.dateCreation).toLocaleString()}</StyledTableCell>
                                </TableRow>
                            )

                        })}
                        {emptyRows > 0 && (
                            <TableRow>
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}
                        <TableRow>
                            <TableCell sx={{ padding: "5px" }} colSpan={6} />
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                labelRowsPerPage="Lignes par page"
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={props.rows.length}
                rowsPerPage={rowsPerPage}
                page={props.page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) =>
                    `Lignes ${from} à ${to} sur ${count !== -1 ? count : `PLUS DE ${to}`}`}
                sx={{
                    '.MuiTablePagination-toolbar': {
                        color: "#18181b !important",
                    },
                    '.MuiTablePagination-selectLabel': {
                        fontFamily: "Plus Jakarta Sans, sans-serif",
                    },
                    '.MuiTablePagination-select': {
                        fontFamily: "Plus Jakarta Sans, sans-serif",
                    },
                    '.MuiTablePagination-displayedRows': {
                        fontFamily: "Plus Jakarta Sans, sans-serif !important",
                        color: "#18181b !important",
                    },
                }}
            />
        </Box>
    )

}

export default SepaTable;